import Layout, { LayoutVariants } from 'components/Layouts/layout';
import React from 'react';
import LocalLayout from './components/layout/layout';

function UserSettings(): JSX.Element {
  return (
    <Layout variant={LayoutVariants.layoutThree}>
      <LocalLayout />
    </Layout>
  );
}

export default UserSettings;
